import { render } from "./blogcard.vue?vue&type=template&id=01a99944&scoped=true"
import script from "./blogcard.vue?vue&type=script&lang=js"
export * from "./blogcard.vue?vue&type=script&lang=js"

import "./blogcard.vue?vue&type=style&index=0&id=01a99944&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a99944"],['__file',"src/js/components/blogcard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01a99944"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01a99944', __exports__)) {
    api.reload('01a99944', __exports__)
  }
  
  module.hot.accept("./blogcard.vue?vue&type=template&id=01a99944&scoped=true", () => {
    api.rerender('01a99944', render)
  })

}


export default __exports__